export const IDENTITY_CONFIG = {
  authority: process.env.REACT_APP_AUTH_URL,
  client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URL,
  silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URL,
  post_logout_redirect_uri: process.env.REACT_APP_LOGOFF_REDIRECT_URL,
  automaticSilentRenew: true,
   monitorSession: true, 
  loadUserInfo: false,
  response_type: process.env.REACT_APP_RESPONSE_TYPE || "code",
  response_mode: process.env.REACT_APP_RESPONSE_MODE || "query",
  scope: process.env.REACT_APP_SCOPE || "openid profile email",
  };

 /* KeyCloak Meta Data
export const METADATA_OIDC = {

  issuer: process.env.REACT_APP_AUTH_URL,
  jwks_uri: `${process.env.REACT_APP_AUTH_URL}/protocol/openid-connect/certs`,
  authorization_endpoint: `${process.env.REACT_APP_AUTH_URL}/protocol/openid-connect/auth`,
  token_endpoint: `${process.env.REACT_APP_AUTH_URL}/protocol/openid-connect/token`,
  userinfo_endpoint: `${process.env.REACT_APP_AUTH_URL}/protocol/openid-connect/userinfo`,
  end_session_endpoint: `${process.env.REACT_APP_AUTH_URL}/protocol/openid-connect/logout`,
  check_session_iframe: `${process.env.REACT_APP_AUTH_URL}/protocol/openid-connect/login-status-iframe.html`,
  revocation_endpoint: `${process.env.REACT_APP_AUTH_URL}/protocol/openid-connect/revoke`,
  introspection_endpoint: `${process.env.REACT_APP_AUTH_URL}/protocol/openid-connect/token/introspect`,

};
*/

/*
const IDENTITY_CONFIG = {
    authority: process.env.REACT_APP_AUTH_URL, //(string): The URL of the OIDC provider.
    client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID, //(string): Your client application's identifier as registered with the OIDC provider.
    client_secret: process.env.REACT_APP_IDENTITY_CLIENT_ID, //(string): Your client application's identifier as registered with the OIDC provider.
    redirect_uri: process.env.REACT_APP_REDIRECT_URL, //The URI of your client application to receive a response from the OIDC provider.
    login: process.env.REACT_APP_AUTH_URL + "/ls/idpinitiatedsignon.aspx",//login",
    automaticSilentRenew: false, //(boolean, default: false): Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration.
    loadUserInfo: true, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
    silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URL, //(string): The URL for the page containing the code handling the silent renew.
    post_logout_redirect_uri: process.env.REACT_APP_LOGOFF_REDIRECT_URL, // (string): The OIDC post-logout redirect URI.
    audience: "https://example.com", //is there a way to specific the audience when making the jwt
    responseType: "id_token token", //(string, default: 'id_token'): The type of response desired from the OIDC provider.
    metadataUrl: "https://adfs40.infocubed.com/FederationMetadata/2007-06/FederationMetadata.xml",
    response_mode: 'query'
    // grantType: "password",
    //scope: "openid example.api", //(string, default: 'openid'): The scope being requested from the OIDC provider.
   // webAuthResponseType: "id_token token"
};

export const METADATA_OIDC = {
    issuer: "http://adfs40.infocubed.com/adfs/services/trust",
    jwks_uri: process.env.REACT_APP_AUTH_URL + "/discovery/keys",//.well-known/openid-configuration/jwks",
    authorization_endpoint: process.env.REACT_APP_AUTH_URL + "/ls/idpinitiatedsignon.aspx",///connect/authorize",
    token_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/token",
    userinfo_endpoint: process.env.REACT_APP_AUTH_URL + "/userinfo", ///connect
    end_session_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/endsession",
    check_session_iframe: process.env.REACT_APP_AUTH_URL + "/connect/checksession",
    revocation_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/revocation",
    introspection_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/introspect",
    
};
*/